import {get, post} from '../index'
export default {
  // 获取门店和课程列表
  getShopAndCourse (querys) {
    return get('/bodybuild/admin/getInfo', querys)
  },
  // 获取教练已安排时间
  getArrangeTime (querys) {
    return get('/bodybuild/admin/arrangeTime', querys)
  },
  // 获取课程安排列表
  getCoursePlanList (querys) {
    return get('/bodybuild/admin/arrange', querys)
  },
  // 获取课程安排详情
  getCoursePlanInfo (querys) {
    return get('/bodybuild/admin/arrangeInfo', querys)
  },
  // 保存课程安排
  saveCoursePlan (querys) {
    return post('/bodybuild/admin/saveArrange', querys)
  },
  // 搜索教练
  searchCardInfo (querys) {
    return get('/bodybuild/admin/cardInfo', querys)
  },
  // 获取课程列表
  getCourseList (querys) {
    return get('/bodybuild/admin/curriculum', querys)
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/fitness.js